import { Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import AlertIllustration from "src/assets/illustrations/infoalertIllustrations";
import useLocales from "src/hooks/useLocales";

const NotFoundPage = () => {
  const { translate } = useLocales();
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location);
  return (
    <>
      <>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            margin: "auto",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              mt: 8,
              textAlign: "center",
              color: "text.primary",
              fontWeight: "bold",
              fontSize: "40px",
            }}
          >
            {translate(`404`)}
          </Typography>
          <Typography variant="h4" sx={{ mt: 2 }}>
            {translate(`Page not found`)}
          </Typography>
          <Box sx={{ mt: 2 }}>
            <AlertIllustration />
          </Box>
          <Typography
            variant="body1"
            sx={{ mt: 2, maxWidth: "30%", textAlign: "center" }}
          >
            {translate(
              `The page you are looking for might have been removed or its name changed or is temporarily unavailable.`
            )}
          </Typography>
          <Button
            onClick={() => navigate("/")}
            variant="contained"
            sx={{
              "&:hover": {
                color: "white",
              },
              mt: 2,
            }}
          >
            {translate("Go to homepage")}
          </Button>
        </Box>
      </>
    </>
  );
};

export default NotFoundPage;
